import { fetchGenreSourcesOptionsAll } from '@intelligence/components/GenreSelectMiddleware/services';

import type { Action, Reducer, Effect } from 'umi';
import type { IGenreRes } from '@intelligence/types/common';

// 全量品类State
interface IGenresPayload {
  // 加载态
  loading: boolean;
  // 全量品类options数据
  data: IGenreRes;
}

// options model State
export interface IOptionsState {
  genres: IGenresPayload;
}

// 全量品类Action
type IGenreAction = Action<'updateGenresOptions'> & { payload: IGenresPayload };

interface IOptionsModel {
  namespace: string;
  state: IOptionsState;
  reducers: {
    updateGenresOptions: Reducer<IOptionsState, IGenreAction>;
  };
  effects: {
    getGenresOptions: Effect;
  };
}

// 系统全量options model namespace
export const OPTIONS_NAMESPACE = 'intelligence_options';

// 全量品类默认数据
const EMPTY_GENRES_DATA: IGenreRes = {
  annir: [],
  ieg: [],
  sensortower: [],
  app_magic: [],
};

/**
 * 维护情报系统 高频公用的 筛选器options数据（全量的）
 */
const options: IOptionsModel = {
  namespace: OPTIONS_NAMESPACE,

  state: {
    // 全量品类options数据
    genres: {
      loading: true,
      data: EMPTY_GENRES_DATA,
    },
  },

  reducers: {
    // 更新全量品类options数据
    updateGenresOptions(state, action) {
      return {
        ...state,
        genres: action.payload,
      };
    },
  },

  effects: {
    // 获取全量品类options数据
    *getGenresOptions({ payload }, { put, call }) {
      try {
        yield put({
          type: 'updateGenresOptions',
          payload: {
            loading: true,
            data: EMPTY_GENRES_DATA,
          },
        });
        const res: { data: IGenreRes } = yield call(fetchGenreSourcesOptionsAll, payload.entityType);
        const resData = res?.data || EMPTY_GENRES_DATA;
        yield put({
          type: 'updateGenresOptions',
          payload: {
            loading: false,
            data: resData,
          },
        });
      } catch (e) {
        yield put({
          type: 'updateGenresOptions',
          payload: {
            loading: false,
            data: EMPTY_GENRES_DATA,
          },
        });
      }
    },
  },
};

export default options;
